import React from 'react'

import { Layer, Shape } from 'react-konva'

interface AnnotationOverlayProps {
  stageBounds: { width: number, height: number }
  activeRectangle: { x: number, y: number, width: number, height: number } | null
}

export const AnnotationOverlay: React.FC<AnnotationOverlayProps> = ({
  stageBounds,
  activeRectangle
}) => {
  // Функция для создания затемнения с вырезанной областью
  const renderOverlay = (context, shape) => {
    const width = shape.width()
    const height = shape.height()

    // Рисуем полупрозрачный фон
    context.fillStyle = 'rgba(0, 0, 0, 0.3)'
    context.fillRect(0, 0, width, height)

    // Вырезаем область под активным прямоугольником
    if (activeRectangle) {
      context.globalCompositeOperation = 'destination-out'
      context.fillStyle = 'rgba(0, 0, 0, 1)'
      context.fillRect(
        activeRectangle.x,
        activeRectangle.y,
        activeRectangle.width,
        activeRectangle.height
      )
      context.globalCompositeOperation = 'source-over'
    }
  }

  return (
    <Layer>
      <Shape
        width={stageBounds.width}
        height={stageBounds.height}
        sceneFunc={renderOverlay}
        listening={false}
      />
    </Layer>
  )
} 
